import { $, $$ } from '@/utilities/helpers';
import Choices from 'choices.js'
import Pristine from 'pristinejs';
import Swal from 'sweetalert2/dist/sweetalert2.js'


let $registerForm = $('#ProSignupForm_ProSignupForm');

let zxcvbn_loaded = false;

/**
 * 
 * Load up the zxcvbn script for password strength
 * 
 */
const loadZXCVBN = () => {
    const script = document.createElement('script');
    script.src = 'https://cdnjs.cloudflare.com/ajax/libs/zxcvbn/4.4.2/zxcvbn.js';
    document.head.appendChild(script);
    zxcvbn_loaded = true;
};

// Pretty strength titles
const strengthText = { 0: 'Worst', 1: 'Bad', 2: 'Weak', 3: 'Good', 4: 'Strong' };


/**
 * 
 * Check the strength of a typed password
 * 
 */
const checkPasswordStrength = (password) => {

    const $bars = $$('.js-strength-bar');
    const result = zxcvbn(password);
    const resultScore = result.score;

    // Update the password strength meter value
    $('.js-strength-name').innerHTML = strengthText[resultScore];

    // Remove all active classes from the bars
    $bars.forEach(($bar) => $bar.classList.remove('active'))

    // Illuminate the bars based on the password strength
    Array.from({ length: resultScore }, (x, i) => $bars[i].classList.add('active'));

    $('.js-strength-lowercase').classList.remove('active');
    $('.js-strength-uppercase').classList.remove('active');
    $('.js-strength-digits').classList.remove('active');
    $('.js-strength-length').classList.remove('active');

    // If we have a password, we need to check for the following
    if (password) {

        // Check for lowercase
        if (password.match(/[a-z]/)) $('.js-strength-lowercase').classList.add('active');

        // Check for uppercase
        if (password.match(/[A-Z]/)) $('.js-strength-uppercase').classList.add('active');

        // Check for digits
        if (password.match(/[0-9]/)) $('.js-strength-digits').classList.add('active');

        // Check for length
        if (password.length >= 8) $('.js-strength-length').classList.add('active');

    }

}

// Add an event listener to the password field to test for strength
if ($('#ChangePasswordForm_ChangePasswordForm_NewPassword1')) {
    if (!zxcvbn_loaded) loadZXCVBN();
    $('#ChangePasswordForm_ChangePasswordForm_NewPassword1').addEventListener('keyup', () => checkPasswordStrength($('#ChangePasswordForm_ChangePasswordForm_NewPassword1').value))
};

if ($registerForm) {

    $('#ProSignupForm_ProSignupForm_SubPosition_Holder').insertAdjacentHTML('beforeend', '<a href="mailto:pro@dermnetnz.org?subject=New%20Position%20Suggestion" class="suggest">Suggest a new position</a>');

    if (!zxcvbn_loaded) loadZXCVBN();

    // Add an event listener to the password field to test for strength
    if ($('#ProSignupForm_ProSignupForm_Password')) {
        $('#ProSignupForm_ProSignupForm_Password').addEventListener('keyup', () => checkPasswordStrength($('#ProSignupForm_ProSignupForm_Password').value))
    };


    let has_tried_to_submit = false;

    let pristine_register = new Pristine($registerForm, {
        classTo: 'middleColumn',
        errorClass: 'error',
        successClass: 'success',
        errorTextParent: 'middleColumn',
    });

    $registerForm.addEventListener('submit', function (e) {

        has_tried_to_submit = true;

        pristine_register = new Pristine($registerForm, {
            classTo: 'middleColumn',
            errorClass: 'error',
            successClass: 'success',
            errorTextParent: 'middleColumn',
        });

        const password = $('#ProSignupForm_ProSignupForm_Password').value;
        const result = zxcvbn(password);
        const resultScore = result.score;

        // Validate the form
        pristine_register.validate();

        // Test for errors
        let errors = pristine_register.getErrors();

        if (errors && errors.length) {
            e.preventDefault();

            errors.forEach((error) => {
                if (error['input'].id === 'ProSignupForm_ProSignupForm_Country') {
                    $('#ProSignupForm_ProSignupForm_Country_Holder .pristine-error').innerHTML = 'This field is required';
                    $('#ProSignupForm_ProSignupForm_Country_Holder .pristine-error').style.display = 'block';
                }
            });

            return false;
        }

    });


    let $position = $('#ProSignupForm_ProSignupForm_Position_Holder');
    let $subPosition = $('#ProSignupForm_ProSignupForm_SubPosition_Holder');
    let $professionalRegistrationBody = $('#ProSignupForm_ProSignupForm_ProfessionalRegistrationBody_Holder');
    let $professionalRegistrationNumber = $('#ProSignupForm_ProSignupForm_ProfessionalRegistrationNumber_Holder');
    let $affiliatedOrganisation = $('#ProSignupForm_ProSignupForm_AffiliatedOrganisation_Holder');
    let $educationInstitute = $('#ProSignupForm_ProSignupForm_EducationInstitute_Holder');
    let $studentNumber = $('#ProSignupForm_ProSignupForm_StudentNumber_Holder');

    if ($position && $subPosition) {

        let $positionSelect = $position.querySelector('select');
        let $positionInput = $position.querySelector('select');

        $positionSelect.value = $positionInput.value;
        $positionSelect.dispatchEvent(new Event('change'));

        window.positionChoice = new Choices($positionSelect, {
            searchEnabled: true,
            searchChoices: true,
            searchResultLimit: 5,
            shouldSort: false,
            itemSelectText: '',
            placeholder: true,
            placeholderValue: 'Select a profession',
        });

        positionChoice.setChoiceByValue($positionInput.value);

        positionChoice.passedElement.element.addEventListener('change', (e) => {
            $positionInput.style.display = 'none';
            $positionInput.value = e.detail.value;
            $position.querySelector('.choices').style.display = 'block';
        });

    }

    const updateSubPositionOptions = (validate = true, position = '', selectedSubPosition = '') => {

        // Reset and show/hide state field
        const $subPositionSelect = $subPosition.querySelector('select');

        $subPositionSelect.innerHTML = '';

        // Update the visibility of the alternative fields
        if (position === 'Student') {

            $educationInstitute.style.display = 'block';
            $studentNumber.style.display = 'block';
            $professionalRegistrationBody.style.display = 'none';
            $professionalRegistrationNumber.style.display = 'none';
            $affiliatedOrganisation.style.display = 'none';

            $professionalRegistrationBody.querySelector('input').removeAttribute('required');
            $professionalRegistrationNumber.querySelector('input').removeAttribute('required');
            $affiliatedOrganisation.querySelector('input').removeAttribute('required');

            $educationInstitute.querySelector('input').setAttribute('required', 'required');
            $studentNumber.querySelector('input').setAttribute('required', 'required');

            $professionalRegistrationBody.querySelector('input').value = '';
            $professionalRegistrationNumber.querySelector('input').value = '';
            $affiliatedOrganisation.querySelector('input').value = '';

        } else if (position === 'Other') {

            $educationInstitute.style.display = 'none';
            $studentNumber.style.display = 'none';
            $professionalRegistrationBody.style.display = 'block';
            $professionalRegistrationNumber.style.display = 'block';
            $affiliatedOrganisation.style.display = 'block';

            $affiliatedOrganisation.querySelector('input').setAttribute('required', 'required');

            $educationInstitute.querySelector('input').removeAttribute('required');
            $studentNumber.querySelector('input').removeAttribute('required');
            $professionalRegistrationBody.querySelector('input').removeAttribute('required');
            $professionalRegistrationNumber.querySelector('input').removeAttribute('required');

            $educationInstitute.querySelector('input').value = '';
            $studentNumber.querySelector('input').value = '';
            $professionalRegistrationBody.querySelector('input').value = '';
            $professionalRegistrationNumber.querySelector('input').value = '';

        } else {

            $professionalRegistrationBody.style.display = 'block';
            $professionalRegistrationNumber.style.display = 'block';
            $affiliatedOrganisation.style.display = 'none';
            $educationInstitute.style.display = 'none';
            $studentNumber.style.display = 'none';

            $affiliatedOrganisation.querySelector('input').removeAttribute('required');
            $educationInstitute.querySelector('input').removeAttribute('required');
            $studentNumber.querySelector('input').removeAttribute('required');

            $professionalRegistrationBody.querySelector('input').setAttribute('required', 'required');
            $professionalRegistrationNumber.querySelector('input').setAttribute('required', 'required');

            $affiliatedOrganisation.querySelector('input').value = '';
            $educationInstitute.querySelector('input').value = '';
            $studentNumber.querySelector('input').value = '';

        }

        pristine_register = new Pristine($registerForm, {
            classTo: 'middleColumn',
            errorClass: 'error',
            successClass: 'success',
            errorTextParent: 'middleColumn',
        });

        // Validate the form
        if (validate) pristine_register.validate();

        if (!window.positions[position]) {
            $subPosition.classList.add('select-hidden');
            return;
        }

        $subPosition.classList.remove('select-hidden');

        // Populate options
        window.positions[position].forEach(position_item => {
            const option = document.createElement('option');
            option.value = position_item
            option.text = position_item;
            if (position_item === selectedSubPosition) option.selected = true;
            $subPositionSelect.appendChild(option);
        });

        if (window.subpositionChoice) window.subpositionChoice.destroy();

        window.subpositionChoice = new Choices($subPositionSelect, {
            searchEnabled: true,
            searchChoices: true,
            searchResultLimit: 5,
            shouldSort: false,
            itemSelectText: '',
            placeholder: true,
            placeholderValue: 'Select a position',
        });

        window.subpositionChoice.setChoiceByValue(selectedSubPosition);
    };

    if ($position) {

        $position.addEventListener('change', (e) => {
            let position = e.target.value;
            updateSubPositionOptions(has_tried_to_submit, position);
        });

        updateSubPositionOptions(false, $position.querySelector('select').value, $subPosition.querySelector('select').value);

    }

}